import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const FleetPolicyPage = lazy(() => import('../pages/FleetPolicyPage'));
const TriggerEventsPage = lazy(() => import('../pages/TriggerEventsPage'));
const TriggersPage = lazy(() => import('../pages/TriggersPage'));
const TriggerPage = lazy(() => import('../pages/TriggerPage'));
const TriggersLandingPage = lazy(() => import('../pages/TriggersLandingPage'));

const routes = [
  {
    path: Location.FLEET_POLICY,
    component: FleetPolicyPage,
    exact: true,
  },
  {
    path: Location.FLEET_POLICY_TYPE,
    component: TriggerEventsPage,
    exact: true,
  },
  {
    path: Location.TRIGGERS,
    component: TriggersPage,
    exact: true,
  },
  {
    path: Location.TRIGGERS_CREATE,
    component: TriggerPage,
    exact: true,
  },
  {
    path: Location.TRIGGERS_EDIT,
    component: TriggerPage,
    exact: true,
  },
  {
    path: Location.FLEET_POLICY_LP,
    component: TriggersLandingPage,
    exact: true,
  },
];

export default routes;
